export default __webpack_public_path__ + "static/media/regulatory--no-heavy-goods-vehicles--g3.91da44ae.png";